<script setup>
import { ref, onMounted, computed, inject } from 'vue'
import { getCookie, getLocalItem } from '@/utils/token'
import { useRouter, useRoute } from 'vue-router'
import { recognition } from './contant.js'
import algorithmItem from './algorithm-item'
import { setTrack } from '@/api/login'
import Application from '@/views/recognition_general/application1.vue'
import { useStore } from 'vuex'
import { CheckCircleFilled } from '@ant-design/icons-vue'
import { getRouteName } from '@/views/algorithm-detail/utils.js'
import { resolveApiAssetUrl } from '@/utils/algorithmPublicAssets'
const store = useStore()

const hasName = [
  'ocrBusinessLicense',
  'ocrBankCard',
  'ocrInvoiceInformation',
  'ocrDriverLicense',
  'faceAppearanceLevel',
  'bodyGestureRecognition',
  'bodyReflectiveVestDetection',
  'ocrHandwritten',
  'classificationGeneral',
  'detectionSmoke',
  'classificationAnimal',
  'classificationVegetables',
  'classificationVehicleType',
  'classificationDishes',
  'classificationLandmark',
  'imageTechSuperResolution',
  'imageTechColorEnhancement',
  'imageTechGeneration',
  'imageTechDepthEstimation',
  'imageTechDefogging',
  'bodyDriverMonitoring',
  'bodyAttribute',
  'bodyGestureRecognition',
]

//路由
const route = useRoute()
const routeSource = route.path.slice(11)
const routeName = getRouteName(route)
const detailData = inject('detailData', null)
const bannerUrl = computed(() =>
  detailData.value?.introduce?.banner_url
    ? resolveApiAssetUrl(detailData.value.introduce.banner_url)
    : '',
)

onMounted(async () => {
  await setTrack({
    position: `algorithm_market > ${routeSource}`,
  })
})

const curData = computed(() => detailData.value || {})
</script>

<template>

  <div class="card">
    <div class="card-bg-black" />
    <div class="card-bg">
      <img v-if="bannerUrl" :src="bannerUrl" />
      <div class="card-msg">
        <div>
          <div class="title">{{ curData?.name }}</div>
          <div class="dec">
            {{ curData?.description }}
          </div>

          <div class="apply">
            <span
              v-for="item in detailData?.introduce?.experience || []"
              class="apply-btn"
              ><CheckCircleFilled
                style="color: #ed000c; margin-right: 14px"
              />{{ item }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Breadcrumb />

  <algorithmItem />

</template>

<style lang="scss" scoped>
.mr16 {
  margin-right: 16px;
}
.white {
  color: #fff;
}
.l-15 {
  margin-left: -15px;
}

.card {
  position: relative;
  color: #fff;
  min-width: 1270px;
  width: 100%;

  &-bg {
    height: 463px;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      object-fit: cover;
    }
  }

  &-bg-black {
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 100%;
  }

  &-msg {
    position: absolute;
    left: 240px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title {
    font-size: 55px;
  }

  .dec {
    font-style: normal;
    margin-top: 16px;
    font-size: 18px;
    color: #fff;
    font-weight: 400;
  }

  .operator {
    margin-top: 40px;
    .consult {
      padding: 9px 15px;
      display: inline-block;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #ffffff;
      cursor: pointer;
    }
  }
}
</style>
